<template>
  <Titulo :texto="`${post.id} - ${post.title}`" />
  <p>{{ post.body }}</p>
</template>

<script>
import Titulo from '@/components/Titulo.vue'

export default {
    components: {
        Titulo,
    },
    data() {
        return {
            post: {id:'', title:'', body:''}
        }
    },
    methods: {
        async getPost() {
            try {
                const data = await fetch('https://jsonplaceholder.typicode.com/posts/' + this.$route.params.id)
                const post = await data.json()

                this.post = post
            } catch (error) {
                console.log(error)
            }
        
        }
    },
    created () {
        this.getPost();
    },
}
</script>

<style>

</style>